import * as go from 'gojs';
import { SIDEBAR_PORT_ID, VIRTUAL_SIDEBAR_PORT_ID } from './../config/common-prop-names';

const $ = go.GraphObject.make;

export type portType = 'top' | 'right' | 'bottom' | 'left';
const virtualPortSize = {
  default: new go.Size(10, 10),
  big: new go.Size(15, 15),
};
const virtualPortMargin = 50;

export const virtualPorts = () => [
  virtualPort('top'),
  virtualPort('right'),
  virtualPort('bottom'),
  virtualPort('left'),
];

export const realPorts = () => [realPort('top'), realPort('right'), realPort('bottom'), realPort('left')];

const realPort = (type: portType) =>
  $(go.Shape, 'Circle', {
    portId: `${SIDEBAR_PORT_ID}_${type}`,
    alignment: getSpot(type),
    alignmentFocus: getSpot(type, 0),
    stroke: null,
    fill: null,
    desiredSize: virtualPortSize.default,
    fromSpot: getSpot(type),
    toSpot: getSpot(type),
    fromLinkable: true,
    toLinkable: true,
  });

const virtualPort = (type: portType) =>
  $(
    go.Shape,
    'Circle',
    {
      portId: `${VIRTUAL_SIDEBAR_PORT_ID}_${type}`,
      alignment: getSpot(type),
      alignmentFocus: getSpot(type, virtualPortMargin),
      stroke: null,
      fill: 'lightblue',
      desiredSize: virtualPortSize.default,
      fromSpot: getSpot(type),
      toSpot: getSpot(type),
      fromLinkable: true,
      toLinkable: false,
      cursor: 'pointer',
      mouseEnter: portMouseEnter,
      mouseLeave: portMouseLeave,
    },
    new go.Binding('fill', 'isSelected', (isSelected) => (isSelected ? 'lightblue' : null)).ofObject(),
  );

const getSpot = (type: portType, margin = 0) => {
  switch (type) {
    case 'top':
      return new go.Spot(0.5, 0, 0, margin);
    case 'right':
      return new go.Spot(1, 0.5, -margin);
    case 'bottom':
      return new go.Spot(0.5, 1, 0, -margin);
    case 'left':
      return new go.Spot(0, 0.5, margin);
  }
};

const portMouseEnter = (_: go.InputEvent, obj: go.GraphObject) => togglePortSize(obj, true);
const portMouseLeave = (_: go.InputEvent, obj: go.GraphObject) => togglePortSize(obj, false);
const togglePortSize = (port: go.GraphObject, big: boolean) => {
  if (!(port instanceof go.Shape)) {
    return;
  }
  port.desiredSize = big ? virtualPortSize.big : virtualPortSize.default;
};
